export const formatPhoneNumber = (phoneNumber: number | string) =>
  phoneNumber.toString().replace(/[^0-9.]/g, '');

export function formatPhoneNumberWithLastFour({
  phoneCode,
  phoneNumber,
  digits,
}: {
  phoneCode: string;
  phoneNumber: string;
  digits: string;
}) {
  return `${phoneCode}${phoneNumber.slice(0, -4)}${digits
    ?.toString()
    ?.padStart(4, '0')}`;
}
